import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // Skip the reset when navigating to an in-page anchor (e.g. /contact-us#contact-form)
        // so the target page's own scrollIntoView isn't immediately overridden.
        if (hash) return;
        window.scrollTo(0, 0);
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
